var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Input from '.';
// onchange example----------------------------------------------------
// export const InputChange = UpdateData => e => {
//     UpdateData({ [e.target.name]: e.target.value });
// }
// const----------------------------------------------------
// InputName------------------------------------------------
export var chtNameCheck = function (chtNum) { return function (value) {
    if (chtNum < 1) {
        return false;
    }
    var regText = '';
    for (var i = 0; i < chtNum; i += 1) {
        regText += '.*[\u4E00-\u9FFF]';
    }
    return value.match(new RegExp("(" + regText + ")", 'g')) !== null;
}; };
export var chtNameError = function (chtNum) { return function (value) {
    return !chtNameCheck(chtNum)(value);
}; };
var InputChtName = function (props) {
    var _a = props.verifiers, verifiers = _a === void 0 ? [] : _a, _b = props.chtNum, chtNum = _b === void 0 ? 2 : _b, other = __rest(props, ["verifiers", "chtNum"]);
    return (React.createElement(Input, __assign({}, other, { verifiers: __spreadArrays(verifiers, [
            { func: chtNameError(chtNum), text: '請填寫正確的中文姓名。' },
        ]) })));
};
export default InputChtName;
